<template>
  <div class="scroll-wrapper">
    <div class="clients-page">
      <div class="clients-toolbar">
        <el-input v-model="searchText" clearable placeholder="Поиск" class="clients-filter" />
        <el-select v-model="selectedSex" placeholder="Пол" clearable class="clients-filter">
          <el-option label="Мужской" value="1" />
          <el-option label="Женский" value="2" />
        </el-select>
        <el-select v-model="selectedCity" placeholder="Город" clearable filterable class="clients-filter">
          <el-option v-for="city in cities" :key="city.id" :label="city.name" :value="city.id" />
        </el-select>
        <el-button type="primary" class="clients-create-btn" @click="openClientModal">Создать клиента</el-button>
      </div>

      <div class="clients-desktop-list">
        <div class="clients-grid clients-grid--head">
          <div class="clients-cell clients-cell--avatar"></div>
          <div class="clients-cell">ФИО</div>
          <div class="clients-cell">Телефон</div>
          <div class="clients-cell">Комментарий</div>
          <div class="clients-cell">Действия</div>
        </div>

        <template v-if="filteredClients.length">
          <div v-for="client in filteredClients" :key="client.id" class="clients-grid clients-grid--row">
            <div class="clients-cell clients-cell--avatar clients-cell--avatar-row">
              <el-avatar
                class="avatar"
                :src="getAvatarSrc(client)"
                :size="40"
                shape="circle">
                {{ getInitials(client.fio) }}
              </el-avatar>
            </div>
            <div class="clients-cell clients-cell--accent">{{ client.fio }}</div>
            <div class="clients-cell clients-cell--accent">{{ client.phone }}</div>
            <div class="clients-cell clients-cell--accent">{{ client.comment || '—' }}</div>
            <div class="clients-cell clients-cell--actions">
              <div class="clients-actions">
                <el-button size="small" type="primary" :icon="EditPen" circle @click="editClient(client)" />
                <el-button size="small" type="danger" :icon="Delete" circle @click="confirmDelete(client)" />
              </div>
            </div>
          </div>
        </template>

        <div v-else class="clients-empty">Клиенты не найдены</div>
      </div>

      <div class="clients-mobile-list">
        <template v-if="filteredClients.length">
          <div class="clients-mobile-head">
            <span class="clients-mobile-head__cell clients-mobile-head__cell--name">ФИО</span>
            <span class="clients-mobile-head__cell clients-mobile-head__cell--phone">Телефон</span>
            <span class="clients-mobile-head__cell clients-mobile-head__cell--comment">Комментарий</span>
            <span class="clients-mobile-head__cell clients-mobile-head__cell--actions"></span>
          </div>
          <article v-for="client in filteredClients" :key="`mobile-${client.id}`" class="clients-mobile-row">
            <div class="clients-mobile-cell clients-mobile-cell--name">
              <el-avatar
                class="avatar"
                :src="getAvatarSrc(client)"
                :size="34"
                shape="circle">
                {{ getInitials(client.fio) }}
              </el-avatar>
              <span class="clients-mobile-name-text">{{ client.fio }}</span>
            </div>
            <div class="clients-mobile-cell clients-mobile-cell--phone">{{ client.phone }}</div>
            <div class="clients-mobile-cell clients-mobile-cell--comment">{{ client.comment || '—' }}</div>
            <div class="clients-mobile-cell clients-mobile-cell--actions">
              <div class="clients-actions">
                <el-button size="small" type="primary" :icon="EditPen" circle @click="editClient(client)" />
                <el-button size="small" type="danger" :icon="Delete" circle @click="confirmDelete(client)" />
              </div>
            </div>
          </article>
        </template>

        <div v-else class="clients-empty">Клиенты не найдены</div>
      </div>

      <el-pagination
        :current-page="page"
        :page-size="pageSize"
        :total="total"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
        class="clients-pagination"
      />

      <ClientForm
        :visible="showClientModal"
        :model="clientForm"
        :cities="cities"
        @save="handleClientFormSave"
        @close="showClientModal = false"
      />

      <el-dialog v-model="showMessageModal" title="Написать клиенту" width="640px" :close-on-click-modal="false">
      <div class="mb-3">
        <div class="mb-1"><strong>Телефон:</strong> {{ messageTargetPhone }}</div>
      </div>

      <el-skeleton :loading="dialogsLoading" animated>
        <template #template>
          <el-skeleton-item variant="text" style="width: 100%; height: 18px; margin-bottom: 8px"/>
          <el-skeleton-item variant="text" style="width: 100%; height: 18px; margin-bottom: 8px"/>
        </template>
        <template #default>
          <div v-if="dialogs.length">
            <div class="mb-2"><strong>Найденные диалоги</strong></div>
            <el-table :data="dialogs" size="small" border>
              <el-table-column prop="messenger_name" label="Профиль" min-width="160">
                <template #default="scope">
                  <span>{{ scope.row.messenger_name }}({{ scope.row.external_id }})</span>
                </template>
              </el-table-column>
              <el-table-column prop="title" label="Диалог" min-width="200"/>
              <el-table-column label="" width="120">
                <template #default="scope">
                  <el-button type="primary" size="small" @click="goToDialog(scope.row)">Открыть</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-else class="mb-2">Диалоги не найдены</div>
        </template>
      </el-skeleton>

      <el-divider/>

      <div class="mb-2"><strong>Новый диалог</strong></div>
      <el-row :gutter="12" class="mb-2">
        <el-col :span="10">
          <el-select v-model="selectedMessengerType" filterable placeholder="Тип мессенджера" @change="selectedMessengerId = null">
            <el-option
              v-for="t in messengerTypes"
              :key="t.value"
              :label="t.label"
              :value="t.value"
            />
          </el-select>
        </el-col>
        <el-col :span="10">
          <el-select v-model="selectedMessengerId" :disabled="!selectedMessengerType" filterable placeholder="Выберите профиль">
            <el-option
              v-for="m in filteredMessengerProfiles"
              :key="m.id"
              :label="`${m.display_name || m.name || ('ID ' + m.id)} • ${m.external_id || ''}`"
              :value="m.id"
              :disabled="existingMessengerIds.has(Number(m.id))"
            />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" :disabled="!selectedMessengerType || !selectedMessengerId" @click="createDialog">Написать</el-button>
        </el-col>
      </el-row>

      <template #footer>
        <el-button @click="closeMessageModal">Закрыть</el-button>
      </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Delete, EditPen } from '@element-plus/icons-vue'
import ClientForm from '@/components/util/clients/ClientForm.vue'

export default {
  name: 'ClientsPage',
  components: { ClientForm },
  data() {
    return {
      searchText: '',
      selectedSex: null,
      selectedCity: null,
      showClientModal: false,
      showBalanceModal: false,
      clientForm: {
        id: null,
        fio: '',
        phone: '',
        sex: null,
        birth_date: '',
        city_id: null,
        address: '',
        inn: '',
        document: '',
        card_number: '',
        refuse_sms: false,
        comment: ''
      },
      balanceClient: null,
      page: 1,
      pageSize: 30,
      showMessageModal: false,
      messageTargetPhone: '',
      messageTargetClientId: null,
      messageTargetClientName: '',
      dialogsLoading: false,
      messengersLoading: false,
      dialogs: [],               // [{ id, messenger_id, messenger_name, title, last_message_preview }]
      activeMessengers: [],      // only messengers with active WA session
      selectedMessengerId: null, // for "new dialog"
      selectedMessengerType: null,
      creatingNew: false,
    }
  },
  computed: {
    Delete() {
      return Delete
    },
    EditPen() {
      return EditPen
    },
    messengerTypes() {
      const types = Array.from(new Set((this.activeMessengers || []).map(m => m.type || 'other')))
      return types.map(t => ({ label: t.toUpperCase(), value: t }))
    },
    filteredMessengerProfiles() {
      const type = this.selectedMessengerType
      if (!type) return []
      return (this.activeMessengers || []).filter(m => (m.type || 'other') === type)
    },
    existingMessengerIds() {
      try {
        return new Set((this.dialogs || []).map(d => Number(d.messenger_id)))
      } catch (_) {
        return new Set()
      }
    },
    ...mapState('clients', ['clients', 'total']),
    ...mapState('cities', ['cities']),
    ...mapState('custom_fields', ['fields']),
    filteredClients() {
      let list = this.clients
      if (this.selectedSex) list = list.filter(c => c.sex === this.selectedSex)
      if (this.selectedCity) list = list.filter(c => c.city_id === this.selectedCity)
      if (this.searchText) {
        const txt = this.searchText.toLowerCase()
        list = list.filter(
          c => c.fio?.toLowerCase().includes(txt) ||
            c.phone?.toLowerCase().includes(txt) ||
            c.card_number?.toLowerCase().includes(txt)
        )
      }
      return list.map(c => ({
        ...c,
        address: this.cities.find(city => city.id === c.city_id)?.name || ''
      }))
    }
  },
  mounted() {
    this.fetchClients()
    this.getCities()
    this.fetchCustomFields({ entity: 'client' })
  },
  watch: {
    selectedSex() {
      this.page = 1
      this.fetchPage()
    },
    selectedCity() {
      this.page = 1
      this.fetchPage()
    },
    searchText() {
      this.page = 1
      this.fetchPage()
    }
  },
  methods: {
    ...mapActions('clients', ['fetchClients', 'saveClient', 'updateClient', 'deleteClient']),
    ...mapActions('cities', ['getCities']),
    ...mapActions('custom_fields', ['fetchCustomFields']),
    ...mapActions('certificates', ['fetchCertificates']),
    ...mapActions('messengers', ['findDialogs', 'getActiveMessengers', 'createDialogAction']),
    openClientModal() {
      this.clientForm = {
        id: null, fio: '', phone: '', sex: '', birth_date: '', city_id: null, address: '',
        inn: '', document: '', card_number: '', refuse_sms: false, comment: ''
      }
      this.showClientModal = true
    },
    editClient(row) {
      this.clientForm = { ...row,
        sex: row.sex > 0 ? row.sex : null }
      this.showClientModal = true
    },
    async handleClientFormSave(data, resolve) {
      // Создание или обновление клиента
      let saved = null
      if (data.id) {
        saved = await this.updateClient(data)
      } else {
        saved = await this.saveClient(data)
      }

      // Берём объект клиента из ответа
      const client = saved?.client || saved

      if (client && client.id) {
        // Обновляем форму в модалке
        this.clientForm = { ...client }
        this.showClientModal = true

        // Возвращаем клиента обратно в форму (через resolve)
        if (typeof resolve === 'function') resolve(client)
      } else {
        if (typeof resolve === 'function') resolve(null)
      }
      await this.fetchClients();
    },
    confirmDelete(row) {
      this.$confirm(`Удалить клиента ${row.fio}?`, 'Подтверждение', {
        type: 'warning'
      }).then(async () => {
        await this.deleteClient(row.id)
        this.fetchClients()
      }).catch(() => {
      })
    },
    handlePageChange(val) {
      this.page = val
      this.fetchPage()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.page = 1
      this.fetchPage()
    },
    async fetchPage() {
      const filters = {
        sex: this.selectedSex,
        city_id: this.selectedCity,
        search: this.searchText,
        page: this.page,
        pageSize: this.pageSize
      }
      await this.fetchClients(filters)
    },
    openBalanceModal(client) {
      this.balanceClient = client
      this.showBalanceModal = true
    },
    onBalanceChanged() {
      this.fetchClients()
    },
    callClient(phone) {
      window.open(`tel:${phone}`)
    },
    messageClient(client) {
      this.openMessageModal(client)
    },
    async openMessageModal(client) {
      this.messageTargetClientId = client?.id || null
      this.messageTargetPhone = client?.phone || ''
      this.messageTargetClientName = client?.fio || client?.name || ''
      this.dialogs = []
      this.activeMessengers = []
      this.selectedMessengerType = null
      this.selectedMessengerId = null
      this.creatingNew = false
      this.showMessageModal = true
      await this.fetchActiveMessengers()
      if (this.messageTargetClientId) {
        await this.fetchDialogsForClient(this.messageTargetClientId)
      } else if (this.messageTargetPhone) {
        // fallback, если нет id — старый путь по телефону
        await this.fetchDialogsForClient(this.messageTargetPhone)
      }
    },
    closeMessageModal() {
      this.showMessageModal = false
      this.selectedMessengerType = null
      this.selectedMessengerId = null
      this.messageTargetClientName = ''
      this.messageTargetClientId = null
      this.messageTargetPhone = ''
      this.dialogs = []
      this.activeMessengers = []
      this.creatingNew = false
    },
    async fetchDialogsForClient(clientId) {
      try {
        this.dialogsLoading = true
        const list = await this.findDialogs({ client_id: clientId })
        this.dialogs = Array.isArray(list) ? list : []
      } catch (e) {
        console.error('fetchDialogsForClient error', e)
        this.dialogs = []
      } finally {
        this.dialogsLoading = false
      }
    },
    async fetchActiveMessengers() {
      try {
        this.messengersLoading = true
        const list = await this.getActiveMessengers()
        this.activeMessengers = Array.isArray(list) ? list : []
      } catch (e) {
        console.error('fetchActiveMessengers error', e)
        this.activeMessengers = []
      } finally {
        this.messengersLoading = false
      }
    },
    goToDialog(dialog) {
      if (!dialog || !dialog.id) return
      // переход на страницу диалога
      if (this.$router) this.$router.push({ path: '/dialogs', query: { dialog_id: dialog.id } })
      else window.location.href = `/dialogs?dialog_id=${dialog.id}`
      this.showMessageModal = false
    },
    async createDialog() {
      if (!this.selectedMessengerType || !this.selectedMessengerId || !this.messageTargetClientId) return
      // защита от дублей: если диалог уже есть для выбранного профиля — не создаём
      if (this.existingMessengerIds.has(Number(this.selectedMessengerId))) {
        this.$message.warning('Диалог для этого профиля уже существует')
        return
      }
      try {
        this.dialogsLoading = true
        const payload = {
          messenger_id: this.selectedMessengerId,
          client_external_id: this.messageTargetClientId,
          client_name: this.messageTargetClientName
        }
        const dialogId = await this.createDialogAction(payload)
        if (dialogId) {
          this.goToDialog({ id: dialogId })
        } else {
          this.$message.error('Не удалось создать диалог')
        }
      } catch (e) {
        console.error('createDialog error', e)
        this.$message.error(e?.message || 'Ошибка при создании диалога')
      } finally {
        this.dialogsLoading = false
      }
    },
    getAvatarSrc(client) {
      if (client.avatar) return client.avatar;
      if (client.sex === 1) return '/img/avatar-male.svg';
      if (client.sex === 2) return '/img/avatar-female.svg';
      if (client.fio) return null; // пусть <el-avatar> покажет инициалы
      return '/img/avatar-male.svg';
    },
    getInitials(fio) {
      if (!fio) return '';
      const parts = fio.trim().split(/\s+/);
      return parts.slice(0, 2).map(p => p[0]?.toUpperCase() || '').join('');
    }
  }
}
</script>

<style scoped>
.avatar {
  font-size: 12px;
}

.clients-page {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 20px 12px 24px;
  color: var(--cal-text-inverse);
  font-family: var(--ui-font-family-base);
}

.scroll-wrapper {
  height: 100%;
  overflow-y: auto;
}

.clients-toolbar {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr) minmax(0, 1.55fr) minmax(190px, 0.7fr);
  gap: 6px;
  margin-bottom: 14px;
  max-width: none;
  padding-left: 78px;
}

.clients-toolbar > .clients-filter:first-child {
  justify-self: stretch;
  width: calc(100% + 78px);
  margin-left: -78px;
}

.clients-create-btn {
  min-height: 42px;
  padding: 0 18px;
  border-radius: 9px;
  justify-self: start;
  width: 100%;
  font-family: var(--ui-font-family-base) !important;
  font-size: 18px !important;
  font-weight: 400 !important;
}

.clients-desktop-list {
  display: block;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.clients-grid {
  display: grid;
  grid-template-columns: 72px 1.15fr 1fr 1.55fr 0.7fr;
  gap: 6px;
  min-width: 860px;
}

.clients-grid + .clients-grid {
  margin-top: 9px;
}

.clients-cell {
  min-height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 18px;
  text-align: center;
  border-radius: 8px;
  font-family: var(--ui-font-family-base) !important;
}

.clients-grid--head .clients-cell {
  background:
    linear-gradient(rgb(0 108 254 / 22%), rgb(0 108 254 / 22%)),
    linear-gradient(180deg, #15264e 0%, #030b1b 100%) !important;
  box-shadow: none !important;
  color: #ffffff !important;
  font-size: 21px;
  font-weight: 700;
  line-height: 1;
}

.clients-grid--row .clients-cell {
  background:
    linear-gradient(180deg, rgba(20, 37, 76, 0.82) 0%, rgba(3, 11, 27, 0.98) 100%) !important;
  box-shadow: inset 0 0 0 1px rgba(24, 49, 97, 0.95) !important;
  color: #ffffff !important;
  font-size: 16px;
  line-height: 1;
  font-weight: 300 !important;
}

.clients-cell--avatar {
  padding-inline: 0;
}

.clients-cell--avatar-row {
  display: flex;
  justify-content: center;
}

.clients-cell--accent {
  color: #22c0ff !important;
  font-weight: 300 !important;
}

.clients-cell--actions {
  padding: 0 12px;
}

.clients-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
}

.clients-mobile-list {
  display: none;
  --clients-mobile-grid: minmax(0, 1.28fr) minmax(0, 1fr) minmax(0, 0.82fr) 82px;
  --clients-mobile-gap: 8px;
  --clients-mobile-inline-padding: 12px;
  --clients-mobile-avatar-size: 34px;
  --clients-mobile-name-gap: 9px;
}

.clients-mobile-head {
  display: grid;
  grid-template-columns: var(--clients-mobile-grid);
  gap: var(--clients-mobile-gap);
  padding: 0 var(--clients-mobile-inline-padding) 6px;
}

.clients-mobile-head__cell {
  min-width: 0;
  display: flex;
  align-items: center;
  color: rgba(174, 194, 230, 0.68);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}

.clients-mobile-head__cell--name {
  padding-left: calc(var(--clients-mobile-avatar-size) + var(--clients-mobile-name-gap));
}

.clients-mobile-head__cell--actions {
  justify-content: flex-end;
}

.clients-mobile-head__cell--phone,
.clients-mobile-head__cell--comment {
  justify-content: center;
  text-align: center;
}

.clients-mobile-row {
  display: grid;
  grid-template-columns: var(--clients-mobile-grid);
  gap: var(--clients-mobile-gap);
  align-items: center;
  min-height: 58px;
  padding: 0 var(--clients-mobile-inline-padding);
  background: #0c224b !important;
  box-shadow: inset 0 0 0 1px rgba(74, 106, 173, 0.08) !important;
  border-radius: 12px !important;
  overflow: visible;
}

.clients-mobile-row + .clients-mobile-row {
  margin-top: 10px;
}

.clients-mobile-cell {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #22c0ff !important;
  font-family: var(--ui-font-family-base) !important;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.clients-mobile-cell--name {
  gap: 9px;
}

.clients-mobile-name-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.clients-mobile-cell--phone,
.clients-mobile-cell--comment {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
}

.clients-mobile-cell--actions {
  justify-content: flex-end;
  overflow: visible;
  padding-right: 2px;
}

.clients-mobile-row .clients-actions {
  width: auto;
  justify-content: flex-end;
  gap: 4px;
  flex-shrink: 0;
}

.clients-empty {
  padding: 36px 20px 0;
  text-align: center;
  color: var(--cal-text-muted);
}

.clients-pagination {
  margin-top: 18px;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  row-gap: 8px;
  overflow: visible;
}

.clients-page :deep(.el-input__wrapper),
.clients-page :deep(.el-select__wrapper) {
  background: #06122c !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  border: none !important;
  min-height: 42px !important;
}

.clients-page :deep(.el-input__inner),
.clients-page :deep(.el-select__placeholder),
.clients-page :deep(.el-select__selected-item) {
  color: #22c0ff !important;
  -webkit-text-fill-color: #22c0ff !important;
  font-family: var(--ui-font-family-base) !important;
  font-size: 18px !important;
  font-weight: 300 !important;
}

.clients-page :deep(.el-input__inner::placeholder) {
  color: #22c0ff !important;
  -webkit-text-fill-color: #22c0ff !important;
  font-weight: 300 !important;
  opacity: 1 !important;
}

.clients-page :deep(.el-select__caret) {
  color: #22c0ff !important;
  font-weight: 300 !important;
}

.clients-page :deep(.el-button--primary:not(.is-plain)) {
  background: var(--appointment-primary);
  border-color: transparent;
  color: var(--appointment-primary-text);
}

.clients-page :deep(.el-button--danger) {
  background: #0c224b !important;
  border: none !important;
  box-shadow: 0 0 0 1px #1b3f7a inset !important;
  color: #ff8d8d !important;
}

.clients-page :deep(.el-button.is-circle) {
  background: #0c224b !important;
  border: none !important;
  box-shadow: 0 0 0 1px #1b3f7a inset !important;
  width: 34px !important;
  height: 34px !important;
  min-width: 34px !important;
  color: #244885 !important;
}

.clients-page :deep(.el-pagination) {
  --el-pagination-bg-color: transparent;
  --el-pagination-button-bg-color: #0c224b;
  --el-pagination-button-color: #aec2e6;
  --el-pagination-text-color: #aec2e6;
  flex-wrap: wrap !important;
  justify-content: flex-end !important;
  row-gap: 8px !important;
}

.clients-page :deep(.el-pagination__total) {
  min-width: max-content;
  padding-left: 6px;
}

.clients-page :deep(.el-pagination .btn-prev),
.clients-page :deep(.el-pagination .btn-next) {
  background: #0c224b !important;
  box-shadow: 0 0 0 1px #1b3f7a inset !important;
  border-radius: 8px !important;
  color: #aec2e6 !important;
}

.clients-page :deep(.el-pagination .btn-prev .el-icon),
.clients-page :deep(.el-pagination .btn-next .el-icon) {
  color: inherit !important;
}

.clients-page :deep(.el-pagination .btn-prev:disabled),
.clients-page :deep(.el-pagination .btn-next:disabled),
.clients-page :deep(.el-pagination .btn-prev.is-disabled),
.clients-page :deep(.el-pagination .btn-next.is-disabled) {
  background: #0c224b !important;
  color: rgba(174, 194, 230, 0.45) !important;
  box-shadow: 0 0 0 1px rgba(27, 63, 122, 0.7) inset !important;
}

.clients-page :deep(.el-pagination .btn-prev:hover),
.clients-page :deep(.el-pagination .btn-next:hover) {
  color: #22c0ff !important;
}

@media (max-width: 991px) {
  .clients-toolbar {
    grid-template-columns: 1fr 1fr;
    max-width: none;
    padding-left: 0;
    gap: 12px;
  }

  .clients-toolbar > .clients-filter:first-child {
    width: 100%;
    margin-left: 0;
  }

  .clients-create-btn {
    justify-self: stretch;
  }
}

@media (max-width: 768px) {
  .clients-page {
    padding: 12px 12px 18px;
  }

  .clients-desktop-list {
    display: block;
  }

  .clients-mobile-list {
    display: none;
  }

  .clients-actions {
    gap: 6px;
  }

  .clients-page :deep(.clients-mobile-row .el-button.is-circle) {
    width: 30px !important;
    height: 30px !important;
    min-width: 30px !important;
  }

  .clients-pagination {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .clients-page {
    padding: 8px 10px 14px;
  }

  .clients-toolbar {
    grid-template-columns: 1fr;
    gap: 10px;
    max-width: none;
    padding-left: 0;
  }

  .clients-toolbar > .clients-filter:first-child {
    width: 100%;
    margin-left: 0;
  }

  .clients-create-btn {
    min-height: 40px;
  }

  .clients-grid {
    min-width: 760px;
  }

  .clients-grid--head .clients-cell {
    min-height: 42px;
    font-size: 14px;
  }

  .clients-grid--row .clients-cell {
    min-height: 44px;
    padding: 0 10px;
    font-size: 12px;
  }

  .clients-page :deep(.el-avatar) {
    width: 28px !important;
    height: 28px !important;
    font-size: 13px !important;
  }

  .clients-page :deep(.el-button.is-circle) {
    width: 26px !important;
    height: 26px !important;
    min-width: 26px !important;
  }
}
</style>

